// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"12bc475a","455":"aad34897"}[chunkId] + ".chunk.js";
};